module.exports = __webpack_public_path__ + "img/php.ca78b013.png";